import { Permission } from "@/gen_src/proto/chalk/auth/v1/permissions_pb";
import {
  GetTeamPermissionsResponse,
  ScimGroup,
  UserRoleAssignment,
} from "@/gen_src/proto/chalk/server/v1/team_pb";

export function getScimGroupsByUserIdGrpc(teamPermissions: GetTeamPermissionsResponse): {
  [userId: string]: ScimGroup[];
} {
  const scimGroupsByUserId: { [userId: string]: ScimGroup[] } = {};
  teamPermissions.scimGroups.forEach((scimGroup) => {
    scimGroup.members.forEach((memberId) => {
      scimGroupsByUserId[memberId] ??= [];
      scimGroupsByUserId[memberId].push(scimGroup);
    });
  });
  return scimGroupsByUserId;
}

export function generatePermissionsByEnvironmentByUserIdGrpc(
  teamPermissions: GetTeamPermissionsResponse,
): { [environmentId: string]: { [userId: string]: Set<Permission> } } {
  const entries = teamPermissions.environmentPermissions.map((environment) => {
    const entriesByUser = environment.userPermissions.map((userPermission) => {
      return [userPermission.userId, new Set(userPermission.userPermissions)];
    });
    return [environment.environmentId, Object.fromEntries(entriesByUser)];
  });
  return Object.fromEntries(entries);
}

export function labeledRolesByEnvironmentByUserId(teamPermissions: GetTeamPermissionsResponse): {
  [environmentId: string]: { [userId: string]: UserRoleAssignment[] };
} {
  const entries = teamPermissions.environmentPermissions.map((environment) => {
    const entriesByUser = environment.userPermissions.map((userPermission) => {
      return [userPermission.userId, userPermission.userRoles];
    });
    return [environment.environmentId, Object.fromEntries(entriesByUser)];
  });
  return Object.fromEntries(entries);
}

export function rolesByPermission(teamPermissions: GetTeamPermissionsResponse) {
  const rolesByPermission: { [P in Permission]: string[] } = {} as { [P in Permission]: string[] };
  teamPermissions.roles.forEach((role) => {
    role.permissions.forEach((permission) => {
      rolesByPermission[permission] ??= [];
      rolesByPermission[permission].push(role.id);
    });
  });
  return rolesByPermission;
}

export function scimRolebindingsByEnvironment(teamPermissions: GetTeamPermissionsResponse) {
  return Object.fromEntries(
    teamPermissions.environmentPermissions.map((env) => [env.environmentId, env.scimRoles]),
  );
}
